import React from "react";
import { connect } from "react-redux";
import ServiceForm from "../../ServiceForm";
import { IService, addService } from "../../../redux/modules/services";
import history from "../../../history";
import "./create-service.css";

interface CreateServicePageProps {
  addService?: (service: IService) => void;
}

class CreateServicePage extends React.Component<CreateServicePageProps> {
  saveServiceHandler = (service: IService) => {
    this.props.addService && this.props.addService(service);
    history.push("/service-list");
  };

  render() {
    return (
      <div className="create-service">
        <div className="create-service__header">
          <h1 className="create-service__title">Додати Послугу</h1>
          <p className="create-service__subtitle">Заповніть інформацію про нову послугу</p>
        </div>
        <div className="create-service__form-container">
          <ServiceForm saveHandler={this.saveServiceHandler} />
        </div>
      </div>
    );
  }
}

export default connect(null, { addService })(CreateServicePage);
